import { LightboxSource } from '../../types';

export const preloadSourcesDependingOnIndex = (sources: LightboxSource[], index: number, count: number) => {
    const isFirstSource = index === 0;
    const isLastSource = index === sources.length - 1;
    const isMiddleSource = !isFirstSource && !isLastSource;

    if (isFirstSource) {
        preloadNextSources(sources, index, count);
    }

    if (isLastSource) {
        preloadPrevSources(sources, index, count);
    }

    if (isMiddleSource) {
        preloadNextSources(sources, index, count);
        preloadPrevSources(sources, index, count);
    }
};

export const preloadElement = (source: LightboxSource) => {
    if (document.head.querySelector(`link[rel="preload"][href="${source.src}"]`)) {
        return;
    }

    const link = document.createElement('link');
    link.href = source.src;
    link.rel = 'preload';

    if (source.type === 'image') {
        link.as = 'image';
    }
    if (source.type === 'video') {
        link.as = 'video';
    }
    if (source.type === 'audio') {
        link.as = 'audio';
    }
    if (source.type === 'pdf') {
        link.as = 'fetch';
    }

    document.head.appendChild(link);
};

export const preloadNextSources = (sources: LightboxSource[], index: number, count: number) => {
    const nextSourceIndex = index + 1;
    const nextSourceIndexPlusCount = index + 1 + count; // next source index, plus the amount of items to preload

    const nextSources = sources.slice(nextSourceIndex, nextSourceIndexPlusCount);
    nextSources.forEach((source) => {
        preloadElement(source);
    });
};

export const preloadPrevSources = (sources: LightboxSource[], index: number, count: number) => {
    const startIndex = index - 1 - count; // the item index before the current source, minus the amount of items to preload

    const prevSources = sources.slice(startIndex, index);
    prevSources.forEach((source) => {
        preloadElement(source);
    });
};
